export default {
  unavailable: {
    title: 'Customer invoices are not available',
    description:
      'Guests ordering at your restaurants cannot request an invoice, so there is nothing to set up here. Order receipts and the invoices your provider issues to you are unaffected.',
  },
};
